

import {Location} from './location';
import {Document} from './document';
import {Chat} from './chat';
import {Partner} from './partner/partner';
import {Flow} from './flow';
import {Equipment} from './equipment';
import {Currency} from './currency';
import {ServicePricing} from './service-pricing';
import {ServiceOrder, ServiceOrderTemplate} from './service-order';
import {Project} from './project';
import {Company} from './companies';

export interface Service {
  id: number;
  description: string;
  name: string;
  projectId?: number;
  supplierId?: number;
  forwarderId?: number;
  shipperId?: number;
  consigneeId?: number;
  technicalSpecifications?: string;
  startDatePlan?: string;
  endDatePlan?: string;
  unitValueLoad?: any;
  unitValueLoadCurrency?: any;
  transportTypeId?: number;
  originId?: number;
  destinationId?: number;
  originContactId?: number;
  destinationContactId?: number;
  customsAgency?: string;
  packaging?: string;
  storage?: string;
  cargoInsurance?: string;
  temperature?: string;
  serviceParentId?: number;
  typeId?: number;
  storageFeeld?: number;
  demurrageFeeld?: number;
  warehouseFeeld?: number;
  isActive?: boolean;
  service?: string;
  integrate: boolean;
  frequency: string;
  servicePrincingId?: number;
  serviceOrderTemplate?: ServiceOrderTemplate;
  project?: Project;
  company: Company;
  customOperations?: string

  // Propiedades de front
  origin?: Location;
  destination?: Location;
  originContact?: Partner;
  destinationContact?: Partner;
  serviceType?: ServiceType;
  type?: ServiceType;
  forwarder?: Partner;
  supplier?: Partner;
  shipper?: Partner;
  consignee?: Partner;
  aduanaAgency?: Partner;
  serviceOrders?: ServiceOrder[];
  documents?: Document[];
  chatId: number;
  chat?: Chat;
  flow?: Flow;
  equipments?: Equipment[];
  servicePricing?: ServicePricing;
}


export interface ServiceCreate {
  "projectId": number,
  "name": string, // Cambiara a name
  "typeId": number,
  "startDatePlan"?: string,
  "endDatePlan"?: string,
  "forwarderId"?: number,
  "supplierId"?: number,
  "shipperId"?: number,
  "consigneeId"?: number,
  "originId"?: string, // Cambiara a originId
  "destinationId"?: string, // Cambiara a destinationId
  originContactId?: number;
  destinationContactId?: number;
  "technicalSpecifications"?: string,
  "frequency"?: string,
  integrate: boolean,
  servicePricingPayload: ServicePricing,
}

export interface ServiceType {
  id: number;
  name: string;
  icon?: string;
  isActive?: boolean;
  flow: Flow;
}

export interface ServiceGood {
  "id": number,
  "amount": number,
  "unitMeasure": string,
  "unitVolume": string,
  "grossUnitWeight": number,
  "unitNetWeight": number,
  "sku": string,
  "serviceId": number,
  "goodId": number
}

export interface ServiceGoodCreate {
  "amount": number,
  "unitMeasure": string,
  "unitVolume": string,
  "grossUnitWeight": number,
  "unitNetWeight": number,
  "sku": string,
  "serviceId": number,
  "goodId": number
}
